export default __webpack_public_path__ + "static/media/AstronomyJupiter_05.65b50815.png";